"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutFragmentText = exports.VariantFragmentText = void 0;
exports.VariantFragmentText = `
  fragment VariantFragment on ProductVariant {
    id
    title
    price {
      amount
    }
    compareAtPrice {
      amount
    }
    availableForSale
    sku
    image {
      url
    }
    selectedOptions {
      name
      value
    }
    product {
      handle
      productType
      vendor
      id
      title
    }
  }
`;
// There are other types of discountApplications
// See https://github.com/Shopify/js-buy-sdk/blob/a1a21d960150105cd45aeda77403c3daccd5bac1/src/graphql/DiscountApplicationFragment.graphql
// when those are needed, apollo requires extra schema setup for union types like that
//
// !!! WHEN THIS CHANGES ALSO UPDATE THE SERVER SIDE FRAGMENT !!!
exports.CheckoutFragmentText = `
  fragment CheckoutFragment on Checkout {
    id
    webUrl
    completedAt
    subtotalPrice {
      amount
    }
    lineItemsSubtotalPrice {
      amount
    }

    appliedGiftCards {
      id
      amountUsed {
        amount
      }
    }

    discountApplications(first: 250) {
      edges {
        node {
          targetSelection
          allocationMethod
          targetType
          value {
            __typename
            ... on MoneyV2 {
              amount
              currencyCode
            }
            ... on PricingPercentageValue {
              percentage
            }
          }
          ... on DiscountCodeApplication {
            code
            applicable
          }
        }
      }
    }

    lineItems(first: 250) {
      edges {
        node {
          id
          title
          quantity
          variant {
            ...VariantFragment
          }

          discountAllocations {
            allocatedAmount {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
  ${exports.VariantFragmentText}
`;
